import { render } from "./CMemberCard.vue?vue&type=template&id=b2af2e82"
import script from "./CMemberCard.vue?vue&type=script&lang=js"
export * from "./CMemberCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__